<div class="user-info-wrapper">
  <div class="error-message" *ngIf="error">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <span>{{error}}</span>
  </div>

  <ion-list id="user-info-container">
    <div class="email-section">
      <ion-item class="email-item" lines="none">
        <div class="email-content">
          <div class="email-label">{{ 'USER_INFO.EMAIL' | translate }}</div>
          <div class="email-value">{{email}}</div>
        </div>
      </ion-item>
      <ion-item class="edit-email-item" lines="none">
        <ion-button 
          *ngIf="!editing" 
          (click)="startEditing()" 
          fill="solid" 
          color="primary" 
          expand="block"
          class="action-button">
          <ion-icon name="create-outline" slot="start"></ion-icon>
          {{ 'USER_INFO.EDIT_EMAIL' | translate }}
        </ion-button>
        <div *ngIf="editing" class="edit-buttons">
          <ion-button (click)="saveChanges()" fill="solid" color="success" class="action-button">
            <ion-icon name="checkmark-outline" slot="start"></ion-icon>
            {{ 'USER_INFO.SAVE' | translate }}
          </ion-button>
          <ion-button (click)="cancelEditing()" fill="outline" color="medium" class="action-button">
            <ion-icon name="close-outline" slot="start"></ion-icon>
            {{ 'USER_INFO.CANCEL' | translate }}
          </ion-button>
        </div>
      </ion-item>
    </div>

    <ion-item 
      class="language-item" 
      button 
      (click)="openLanguageSwitcher()" 
      *ngIf="isToggleEnabled('internationalization')"
      lines="none">
      <ion-icon name="language-outline" slot="start" color="primary"></ion-icon>
      <ion-label>
        <h3>{{ 'USER_INFO.LANGUAGE' | translate }}</h3>
      </ion-label>
      <div slot="end" class="language-display">
        <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
        <span class="language-name">{{ currentLanguageInfo.name }}</span>
        <ion-icon name="chevron-forward" color="medium"></ion-icon>
      </div>
    </ion-item>
  </ion-list>
</div>
